import React from "react";
import { Skeleton } from "@mui/material";

const BiomedicalCard = ({ largeText, smallText, width, midText = false, bgColor, loading = false }) => {
  const styles = {
    card: {
      backgroundColor: bgColor || "#FFF6E5",
      color: "black",
      borderRadius: "12px",
      padding: "15px 20px",
      display: "inline-block",
      textAlign: "center",
      boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
      width: width ? width : "100%",
      height: "100px",
      margin: "15px"
    },
    largeText: {
      fontSize: "30px",
      fontWeight: "bold",
      marginBottom: "5px"
    },
    midText: {
      fontSize: "20px",
      fontWeight: "bold",
      marginBottom: "5px"
    },
    smallText: {
      fontSize: "13px",
      fontWeight: "bold"
    }
  };

  return (
    <div style={styles.card}>
      {loading ? <Skeleton width="70%" height={38} sx={{ mx: "auto" }} /> : midText ? (
        <div style={styles.midText}>{midText}</div>
      ) : (
        <div style={styles.largeText}>{largeText}</div>
      )}
      <div style={styles.smallText}>{smallText}</div>
    </div>
  );
};

export default BiomedicalCard;
